import script from "./registerSjList.vue?vue&type=script&setup=true&lang=js"
export * from "./registerSjList.vue?vue&type=script&setup=true&lang=js"

import "./registerSjList.vue?vue&type=style&index=0&id=f62234b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f62234b2"]])

export default __exports__